import { Component, OnInit } from '@angular/core';

import { Seguro } from "../shared/seguro.model";
import { SeguroApiService } from "../shared/seguro-api.service";
import { SeguroService } from "../shared/seguro.service";
import { SeguroNavigationService } from "../shared/seguro-navigation.service";
import { segurosModuleName } from "../shared/data.service";
import { UtilService } from "../../../shared/services/util.service";
import { PessoaJuridicaApiService } from "../../../recursos-humanos/pessoa-juridica/shared/pessoa-juridica-api.service";

@Component({
  selector: 'app-seguro-list',
  template: require('./seguro-list.component.html'),
  styles: [require('./seguro-list.component.css')]
})
export class SeguroListComponent implements OnInit {
  list: Seguro[] = [];
  loading: boolean = true;
  showDisabled: boolean = false;
  segurosModuleName: any = segurosModuleName;

  constructor(
    private _segurosApiService: SeguroApiService,
    private _seguroService: SeguroService,
    private _seguroNavigationService: SeguroNavigationService,
    private _pessoaJuridicaApiService: PessoaJuridicaApiService,
    private _utilService: UtilService
  ) { }

  ngOnInit() {
    this.getAll();
  }

  clickNew() {
    this._seguroService.clearSessionStorage();
    this._seguroNavigationService.goToNew();
  }

  clickEdit(item: Seguro) {
    this._seguroService.clearSessionStorage();
    this._seguroNavigationService.goToEdit(item.id);
  }

  clickDelete(item: Seguro) {
    var onDelete = (function() {
      this.onDelete(item);
    }.bind(this));

    this._utilService.swalMessageDelete(onDelete);
  }

  private getAll() {
    var onDone = (function(Response) {
      if (!Response.error)  {
        this.list = Response;
      }
      this.loading = false;
    }.bind(this));

    this._segurosApiService.onGetAll(onDone);
  }

  private onDelete(item) {
    var onDone = (function (Response) {
      if (!Response.error) {
        var x: number, lenX: number;
        for (x = 0, lenX = this.list.length; x < lenX; x++) {
          if (this.list[x].id === item.id) {
            this.list[x].ativo = false;
            break;
          }
        }
        this._utilService.swalMessageDeleteSuccess();

        this.deletePessoaJuridica(item.pessoaJuridicaId);
      } else {
        this._utilService.swalMessageDeleteError();
      }
    }.bind(this));

    this._segurosApiService.onDelete(item.id, onDone);
  }

  private deletePessoaJuridica(pessoJuridicaId:  number) {
    var onDone = (function (Response) {

    });

    this._pessoaJuridicaApiService.onDelete(pessoJuridicaId, onDone);
  }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/despachos/seguros/seguro-list/seguro-list.component.ts
 **/